const sidebarNav = [
  {
    link: "/",
    section: "dashboard",
    icon: "lucide:layout-dashboard", //width:"20"
    text: "Dashboard",
  },
    {
    link: "/reports",
    section: "reports",
    icon: "material-symbols:table-chart-view-outline-sharp",
    text: "Reports",
  },
  {
    link: "/products",
    section: "products",
    icon: "icon-park-outline:ad-product",
    text: "Products",
  },
  {
    link: "/employees",
    section: "employees",
    icon: "ph:users-bold",
    text: "Employees",
  },
  {
    link: "/distributors",
    section: "distributors",
    icon: "icon-park-outline:transaction-order",
    text: "Distributors",
  },
  {
    link: "/sales",
    section: "sales",
    icon: "nimbus:discount-circle",
    text: "Sales",
  },
  {
    link: "/trips",
    section: "trips",
    icon: "material-symbols:directions-bike-sharp",
    text: "Trips",
  },
  {
    link: "/shops",
    section: "shops",
    icon: "material-symbols:shopping-bag-speed-outline-sharp",
    text: "Shops",
  },
  {
    link: "/attendances",
    section: "attendances",
    icon: "ic:round-inventory",
    text: "Attendances",
  },
  {
    link: "/beats",
    section: "beats",
    icon: "material-symbols:route-outline",
    text: "Beats",
  },
  {
    link: "/services",
    section: "services",
    icon: "material-symbols:rule-settings",
    text: "Services",
  },
];

export default sidebarNav;
